import type { UserOrgProfile } from '@/api/user/profile'

export function isSysAdmin(profile?: UserOrgProfile): boolean {
  return profile?.sys_admin === true
}
